import template from './card9.html';
import controller from './card9.controller';
import './card9.scss';

let card9Component = {
    bindings: {
        'color': '=',
        'data': '='
    },
    template,
    controller
};

export default card9Component;



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/card9/card9.component.js